/* eslint max-len: 0 */

import React from 'react';
//import Link from 'gatsby-link';
import Helmet from 'react-helmet';
import styled from 'react-emotion';

import config from '../../config/website';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Container from '../components/Container';

import SlideUp from '../components/ani/SlideUp';
import Browser from '../util/Browser';

//import FillBg from '../components/FillBg';

let SlideUp00 = styled.div``;

const ErrorPage = () => {
  if (Browser() === 'chrome') {
    SlideUp00 = SlideUp;
  }
  if (typeof window !== 'undefined') {
    if (window.parent.location === self.location) { 
  return (
    <React.Fragment>
      <Helmet title={`404 | ${config.siteTitle}`} />
      <Header slim title={`:${'\u00A0'}:${'\u00A0'}404${'\u00A0'}:${'\u00A0'}:`} />
      <Container>
        <SlideUp00 delay={320}>
          <div style={{ marginLeft: '4rem' }}>
            <p />
            <h1>ERROR 404 </h1>
            <h3>The page you are looking for cannot be found. Refresh & try again soon.</h3>
            <p>
              {' '}
          NOTE: if you are trying to reach a game the file most likely is there, but the host throttled and cut the connection. Please try again, ideally with a fast, wired connection.
          </p>
            <p>
              {' '}
            Browse{' '}
              <a href="https://GitHub.com/Sondro" target="_blank" rel="nofollow noopener noreferrer">
                GitHub.com/Sondro
            </a>{' '}
              <span role="img" aria-label="wink">
                😉
            </span>
            </p>
            <p />
          </div>
        </SlideUp00>
        <div
          style={{
            position: 'relative',
            paddingBottom: '56.25%',
            overflow: 'hidden',
            width: '100%',
            height: 'auto',
            marginBottom: '2rem',
          }}
        >
          <iframe
            style={{
              position: 'absolute',
              top: '0',
              left: '0',
              width: '100%',
              height: '100%',
            }}
            title="Sondro Playlist"
            width="560"
            height="315"
            src=""
            // src="https://www.youtube.com/embed/videoseries?list=
            frameBorder="0"
            allowFullScreen
          />
        </div>
      </Container>
      <Footer />
    </React.Fragment>
  );
}
else {
  // alert('app');
  return (<div />);
}
}
return (<div />);
};
export default ErrorPage;

/*
            Check the{' '}
            <a href="../sitemap" target="_blank" rel="nofollow noopener noreferrer">
              Sitemap
            </a>{' '}
            or browse{' '}
*/


// WEBPACK FOOTER //
// ./src/pages/404.jsx